import styled, { createGlobalStyle } from 'styled-components'

/* Centro de notificações: o sino do cabeçalho, o painel que ele abre e o modal com a lista
   completa. Paleta e medidas seguem os cartões da nova identidade (menu de conta, filtros
   salvos): título #101828, texto #5b6b7f, apoio #98a2b3, azul #2c5f9e. */

export const NotificationsContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  margin-left: 1rem;

  .notifications__trigger {
    position: relative;
    display: flex;
    padding: 4px;
    border-radius: 999px;
    background: none;
    color: #fff;
    transition: background-color 160ms;
    /* Sem font-size aqui de propósito: o sino acompanha os outros ícones do cabeçalho, que o
       próprio cabeçalho dimensiona em 2rem. */
    svg {
      margin: 0;
    }
    &:hover,
    &.is-open {
      background: rgba(255, 255, 255, 0.12);
    }
    &:focus-visible {
      outline: 2px solid #f5a623;
      outline-offset: 2px;
    }
  }

  /* O anel da cor do cabeçalho separa o contador do sino sem precisar de espaço extra. */
  .notifications__badge {
    position: absolute;
    top: -2px;
    right: -4px;
    min-width: 18px;
    height: 18px;
    padding: 0 4px;
    border-radius: 999px;
    background: #d92d20;
    box-shadow: 0 0 0 2px #2b3c5b;
    font-size: 10px;
    font-weight: 800;
    line-height: 18px;
    color: #fff;
    text-align: center;
  }

  /* A variável --shift empurra o cartão de volta para dentro da tela quando o sino está perto da borda
     esquerda (o cabeçalho quebra em duas linhas abaixo de ~950px); a seta desconta o mesmo
     valor e continua apontando para o sino. */
  .notifications__card {
    position: absolute;
    top: calc(100% + 12px);
    right: -6px;
    z-index: 1000000001;
    width: min(380px, calc(100vw - 16px));
    transform: translateX(var(--shift, 0px));
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 12px 30px rgba(16, 24, 40, 0.2);
    overflow: hidden;
    color: #344054;
    text-align: left;
    /* Seta apontando para o sino. */
    &::before {
      content: '';
      position: absolute;
      top: -6px;
      right: calc(17px + var(--shift, 0px));
      border-left: 7px solid transparent;
      border-right: 7px solid transparent;
      border-bottom: 7px solid #fff;
    }
  }

  .notifications__header {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 13px 16px;
    border-bottom: 1px solid #f0f2f5;
    strong {
      flex: 1;
      font-size: 15px;
      font-weight: 700;
      color: #101828;
    }
  }

  .notifications__pill {
    padding: 3px 9px;
    border: 1px solid #cfe0f3;
    border-radius: 1rem;
    background: #f2f7fd;
    font-size: 11.5px;
    font-weight: 700;
    color: #2c5f9e;
    white-space: nowrap;
  }

  .notifications__list {
    max-height: 368px;
    overflow-y: auto;
  }

  .notifications__item {
    display: flex;
    gap: 10px;
    width: 100%;
    padding: 12px 14px 12px 16px;
    border: none;
    background: none;
    text-align: left;
    cursor: pointer;
    transition: background-color 120ms;
    & + .notifications__item {
      border-top: 1px solid #f4f6f8;
    }
    &:hover {
      background: #f7f9fc;
    }
    &.is-unread {
      background: #f8fbff;
      &:hover {
        background: #eff5fd;
      }
    }
    &:focus-visible {
      outline: 2px solid #2c5f9e;
      outline-offset: -2px;
    }
  }

  /* Some no lido, mas continua ocupando a coluna para o texto não dançar de item para item. */
  .notifications__dot {
    flex-shrink: 0;
    width: 7px;
    height: 7px;
    margin-top: 6px;
    border-radius: 50%;
    background: #2c5f9e;
    &.is-hidden {
      visibility: hidden;
    }
  }

  .notifications__item_body {
    flex: 1;
    min-width: 0;
  }

  .notifications__item_title {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    font-size: 13.5px;
    font-weight: 700;
    line-height: 1.35;
    color: #101828;
  }

  .notifications__item_text {
    margin: 3px 0 0;
    font-size: 12.5px;
    line-height: 1.45;
    color: #5b6b7f;
    /* As descrições longas vêm com quebras de linha do servidor. */
    white-space: pre-line;
    word-break: break-word;
    &.is-clamped {
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
    }
  }

  .notifications__item_footer {
    display: flex;
    align-items: center;
    gap: 9px;
    margin-top: 6px;
    time {
      font-size: 11px;
      color: #98a2b3;
    }
  }

  .notifications__see_all {
    padding: 0;
    border: none;
    background: none;
    font-size: 11.5px;
    font-weight: 700;
    color: #2c5f9e;
    &:hover {
      text-decoration: underline;
    }
  }

  /* O cabeçalho dimensiona todo ícone de botão dos widgets por um seletor pesado
     (".cont .widgets button svg { font-size: 2rem }"), e o cartão abre dentro dele. Os dois
     seletores abaixo repetem a classe do cartão de propósito: é o peso que falta para os ícones
     do painel manterem o tamanho próprio em vez de saírem com 2rem. */
  .notifications__card.notifications__card .notifications__read {
    flex-shrink: 0;
    width: 26px;
    height: 26px;
    border: none;
    border-radius: 50%;
    background: none;
    color: #b0b7c3;
    svg {
      margin: 0;
      font-size: 16px;
    }
    &:hover {
      background: #eaf1fa;
      color: #2c5f9e;
    }
  }

  .notifications__empty {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 5px;
    padding: 34px 20px;
    text-align: center;
    svg {
      margin: 0 0 4px;
      font-size: 30px;
      color: #cfd6e0;
    }
    strong {
      font-size: 13.5px;
      color: #344054;
    }
    span {
      font-size: 12px;
      color: #98a2b3;
    }
  }

  .notifications__skeleton {
    display: flex;
    flex-direction: column;
    gap: 7px;
    padding: 14px 16px;
    & + .notifications__skeleton {
      border-top: 1px solid #f4f6f8;
    }
  }

  .notifications__card.notifications__card .notifications__footer {
    padding: 8px;
    border-top: 1px solid #f0f2f5;
    background: #fbfcfd;
    > button {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 6px;
      width: 100%;
      padding: 9px;
      border: none;
      border-radius: 8px;
      background: none;
      font-size: 13px;
      font-weight: 700;
      color: #2c5f9e;
      svg {
        margin: 0;
        font-size: 15px;
      }
      &:hover {
        background: #eef4fb;
      }
    }
  }
`

/** O Modal do bootstrap não tem largura nem cantos da identidade nova. */
export const NotificationsModalStyles = createGlobalStyle`
  .modal-dialog.notifications-modal {
    max-width: 760px;
  }
  .notifications-modal .modal-content {
    border: none;
    border-radius: 12px;
    box-shadow: 0 20px 50px rgba(16, 24, 40, 0.24);
    overflow: hidden;
    background: #fff;
  }
  /* O padding do .modal-body global brigaria com o cabeçalho e o rodapé colados nas bordas. */
  .notifications-modal .modal-body {
    padding: 0;
  }
`

export const NotificationsModalContent = styled.div`
  display: flex;
  flex-direction: column;
  color: #344054;

  .notifications_modal__header {
    display: flex;
    align-items: center;
    gap: 11px;
    padding: 16px 18px;
    border-bottom: 1px solid #f0f2f5;
    .notifications_modal__header_icon {
      margin: 0;
      font-size: 22px;
      color: #2c5f9e;
    }
    h5 {
      margin: 0;
      font-size: 19px;
      font-weight: 700;
      color: #101828;
    }
    .notifications_modal__pill {
      padding: 3px 9px;
      border: 1px solid #cfe0f3;
      border-radius: 1rem;
      background: #f2f7fd;
      font-size: 11.5px;
      font-weight: 700;
      color: #2c5f9e;
      white-space: nowrap;
    }
    > button {
      margin-left: auto;
      display: flex;
      padding: 0;
      border: none;
      background: none;
      color: #98a2b3;
      svg {
        margin: 0;
        font-size: 22px;
      }
      &:hover {
        color: #344054;
      }
    }
  }

  .notifications_modal__list {
    max-height: 62vh;
    overflow-y: auto;
  }

  .notifications_modal__day {
    position: sticky;
    top: 0;
    z-index: 1;
    padding: 7px 18px;
    border-bottom: 1px solid #f4f6f8;
    background: #fbfcfd;
    font-size: 10px;
    font-weight: 800;
    letter-spacing: 0.12em;
    text-transform: uppercase;
    color: #b0b7c3;
  }

  .notifications_modal__item {
    display: flex;
    align-items: flex-start;
    & + .notifications_modal__item {
      border-top: 1px solid #f4f6f8;
    }
    &.is-unread {
      background: #f8fbff;
    }
    &.is-expanded {
      background: #fff;
      box-shadow: inset 3px 0 0 #2c5f9e;
    }
  }

  .notifications_modal__summary {
    display: flex;
    flex: 1;
    min-width: 0;
    gap: 11px;
    padding: 13px 8px 13px 18px;
    border: none;
    background: none;
    text-align: left;
    &:hover {
      background: rgba(44, 95, 158, 0.04);
    }
    &:focus-visible {
      outline: 2px solid #2c5f9e;
      outline-offset: -2px;
    }
  }

  .notifications_modal__dot {
    flex-shrink: 0;
    width: 7px;
    height: 7px;
    margin-top: 7px;
    border-radius: 50%;
    background: #2c5f9e;
    &.is-hidden {
      visibility: hidden;
    }
  }

  .notifications_modal__body {
    flex: 1;
    min-width: 0;
    strong {
      display: block;
      font-size: 14px;
      font-weight: 700;
      line-height: 1.35;
      color: #101828;
    }
    .notifications_modal__preview {
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
      margin: 3px 0 0;
      font-size: 12.5px;
      line-height: 1.45;
      color: #5b6b7f;
      white-space: pre-line;
      word-break: break-word;
    }
    time {
      display: block;
      margin-top: 6px;
      font-size: 11px;
      color: #98a2b3;
    }
  }

  .notifications_modal__chevron {
    flex-shrink: 0;
    margin: 4px 0 0;
    font-size: 17px;
    color: #b0b7c3;
  }

  .notifications_modal__actions {
    display: flex;
    align-items: center;
    padding: 13px 14px 0 0;
    > button {
      width: 28px;
      height: 28px;
      border: none;
      border-radius: 50%;
      background: none;
      color: #b0b7c3;
      svg {
        margin: 0;
        font-size: 16px;
      }
      &:hover {
        background: #eaf1fa;
        color: #2c5f9e;
      }
    }
  }

  /* Texto integral da notificação. O teto de altura vale aqui: descrição de milhares de
     caracteres (erro de pagamento, resposta de sacado) rola dentro do próprio bloco em vez de
     empurrar a lista inteira. */
  .notifications_modal__detail {
    padding: 0 18px 15px 47px;
    p {
      max-height: 300px;
      margin: 0;
      padding: 12px 14px;
      overflow-y: auto;
      border: 1px solid #e3e8ef;
      border-radius: 10px;
      background: #fbfcfd;
      font-size: 13px;
      line-height: 1.6;
      color: #344054;
      white-space: pre-line;
      word-break: break-word;
    }
  }

  .notifications_modal__empty {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 5px;
    padding: 56px 20px;
    text-align: center;
    svg {
      margin: 0 0 4px;
      font-size: 34px;
      color: #cfd6e0;
    }
    strong {
      font-size: 14px;
      color: #344054;
    }
    span {
      font-size: 12.5px;
      color: #98a2b3;
    }
  }

  .notifications_modal__skeleton {
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding: 15px 18px;
    & + .notifications_modal__skeleton {
      border-top: 1px solid #f4f6f8;
    }
  }

  .notifications_modal__footer {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 12px 18px;
    border-top: 1px solid #f0f2f5;
    background: #fbfcfd;
    > small {
      flex: 1;
      font-size: 12px;
      color: #98a2b3;
    }
    > button {
      display: flex;
      align-items: center;
      gap: 7px;
      padding: 8px 15px;
      border: 1px solid #cfe0f3;
      border-radius: 8px;
      background: #fff;
      font-size: 13px;
      font-weight: 700;
      color: #2c5f9e;
      svg {
        margin: 0;
        font-size: 15px;
      }
      &:hover:not(:disabled) {
        background: #f2f7fd;
      }
      &:disabled {
        opacity: 0.65;
      }
    }
  }
`
